import { get, set } from "local-storage";

export function setLocalVar(key: string, value: any) {
  return set(key, value);
}

export function getLocalVar(key: string) {
  return get(key);
}
